import { useGetDepartmentByEmployee } from '../services/api';
import { SimpleDepartmentsTable } from './DepartmentsTableSimple';

export const EmployeeDepartmentsTable: React.FC<{ employeeId: number }> = ({ employeeId }) => {
  const { data, error, isLoading } = useGetDepartmentByEmployee({ employeeId });
  return <SimpleDepartmentsTable data={data} isLoading={isLoading} error={error} />;
};
